import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./PretendardVariable.woff2%22,%22display%22:%22swap%22,%22weight%22:%2245%20920%22,%22variable%22:%22--font-pretendard%22,%22preload%22:true,%22fallback%22:[%22system-ui%22,%22sans-serif%22]}],%22variableName%22:%22pretendard%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'pretendard', 'pretendard Fallback', system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
